const scienceGlossaryUrl = '/science-glossary';

export default scienceGlossaryUrl;
